export default __webpack_public_path__ + "static/media/tiger_7.04d70cf3.mp3";